"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireWildcard(require("./Icon"));
const _excluded = ["fill"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IconShieldHalf = _ref => {
  let {
      fill
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    label: "Shield Half"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 3.5611V9.69C12.4 10.2641 12.3019 10.6456 12.1626 10.9369C12.021 11.2329 11.7915 11.5304 11.3963 11.8758C10.9882 12.2325 10.449 12.602 9.71802 13.0603C9.45537 13.225 9.11408 13.4336 8.74013 13.6622C8.50266 13.8073 8.25203 13.9605 8 14.1156V2.02354C8.85106 2.61738 9.66686 3.01317 10.5295 3.25644C11.157 3.43341 11.7787 3.51941 12.4 3.5611ZM6.47266 15.0564C6.94679 15.3457 7.45628 15.6566 8 16C8.54372 15.6566 9.05321 15.3457 9.52734 15.0564C12.4232 13.2891 14 12.3269 14 9.69V2C11.656 2 10.2473 1.91067 8 0C5.75267 1.91067 4.344 2 2 2V9.69C2 12.3269 3.57676 13.2891 6.47266 15.0564Z",
    fill: fill
  }));
};
IconShieldHalf.defaultProps = {
  fill: 'black'
};
IconShieldHalf.propTypes = Object.assign({
  fill: _propTypes.default.string
}, _Icon.propTypes);
var _default = exports.default = IconShieldHalf;